/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{multiplyOpacityToUnitRGBA as o}from"../../../../core/colorUtils.js";import{fromValues as r}from"../../../../core/libs/gl-matrix-2/factories/vec4f64.js";const t=r(0,0,0,.04);function c({accentColor:r}){return o(r,.5)}function e({accentColor:r}){return o(r,.7)}export{c as getGridColor,e as getOutlineColor,t as planeColor};
